import React,{useState,useEffect,useLocation} from 'react';
import NewEmployeeAdd from '../../views/PartnerView/NewEmployeeAdd';

const PartnerEmployeeAddComponent=()=>{

    return(<NewEmployeeAdd />);
};
export default PartnerEmployeeAddComponent;